import React from "react";
import { Container, Row, Col, ListGroup, Image } from "react-bootstrap";
import { useState, useEffect } from "react";
import Title from "../Title/Title";
import { services } from "../../Config/Services";

export default function Services() {
  const [serviceKey, setOpen] = useState({ title: services[0].title, index: 0 });
  const [isMobile, setIsMobile] = useState(window.matchMedia("(max-width: 768px)").matches);
  useEffect(() => {
    window.addEventListener("resize", setIsMobile(window.matchMedia("(max-width: 768px)").matches));
    return () => {
      window.removeEventListener("resize", setIsMobile(window.matchMedia("(max-width: 768px)").matches));
    };
  }, []);

  let ourList = null;
  ourList = (
    <ul className='leafList'>
      {services.map((service, index) => {
        return (
          <li key={index} className="serviceListItem my-1">
            {service.title}
          </li>
        );
      })}
    </ul>
  );

  return (
    <Container fluid className="servicesContainer">
      <Title title1={'Our Services'} title2={'A comprehensive list of our services'}></Title>
      <Row className="servicesRow justify-content-center mx-auto py-1">
        <Row className="serviceRow">
          <Col xs={12} md={7} className="px-0 pb-4 serviceDescription">
            <p>
            In the Greater Springfield area, <strong>East Village Landscaping</strong> is your premier landscaping specialist. We're dedicated to enhancing your outdoor spaces, emphasizing the beauty and functionality of your surroundings.
            </p>
            <p>
            Our services cover a wide spectrum, from <strong className={'lightGreen'}>Patios or Retaining Walls</strong> to expert <strong className={'lightGreen'}>Lawn Care</strong> and <strong className={'lightGreen'}>Weekly/Bi-Weekly Lawn Mowing</strong> for lush, well-maintained lawns. Our team handles <strong className={'lightGreen'}>Small Tree/Limb/Bush Removal</strong>, <strong className={'lightGreen'}>Brush Removal</strong>, and <strong className={'lightGreen'}>Hedge Trimming</strong> to create safe and inviting landscapes.
            </p>
            <p>
            You can rely on us for <strong className={'lightGreen'}>Spring/Fall Yard Cleanups, Lawn Repair, Overseeding, and Aerating</strong> to keep your grass healthy and thriving. We also specialize in <strong className={'lightGreen'}>Landscape Design, Gutter Cleaning, and Fencing</strong> to turn your outdoor vision into reality.
            </p>
            <p>
            Nestled in the Greater Springfield area of Massachusetts - East Village Landscaping is committed to providing comprehensive landscaping solutions that transform your property. Get in touch with us today, and let's start making your outdoor space truly extraordinary.
            </p>
            <p className='cta text-center'><a href="/services/#ContactUs">CONTACT US</a></p>
          </Col>
          <Col xs={12} md={5} className="px-0">
            {ourList}
          </Col>
        </Row>
      </Row>
    </Container>
  );
}